import { useMutation } from "@tanstack/react-query";
import { errorToast } from "@telluscompany/design-system";
import { useLocalization } from "@i18n";

import { axiosPostData } from "@shared/api/clients";
import {
  SelectTenantRequest,
  SelectTenantResponse,
} from "./SelectTenant.types";

export const selectTenant = async ({
  tenantId,
}: SelectTenantRequest): Promise<SelectTenantResponse> => {
  const response = await axiosPostData<
    SelectTenantResponse,
    SelectTenantRequest
  >("v1/auth/select-tenant", { tenantId });
  return response;
};

export const useSelectTenantMutation = () => {
  const gs3LegacyUrl =
    import.meta.env.VITE_GS3_LEGACY_FRONTEND_URL || "http://localhost:5173";
  const { translate } = useLocalization();

  return useMutation({
    mutationFn: selectTenant,
    onSuccess: () => {
      window.location.href = gs3LegacyUrl;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        translate("auth.errorSelectingTenant");
      errorToast({
        title: translate("common.error"),
        description: errorMessage,
      });
    },
  });
};
